let debug = true;
//let token = location.search.split('token=')[1];
let videoUrl = 'https://elbetvideo.s3.amazonaws.com/HorseRacing';
let oldTicket = null;
let iosVersion = iOSversion();
let iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
let checkIos = iOS ? iosVersion[0] : 10;
let language = lang === null ? 'en' : lang;

import Api from './api/api';
import Auth from './auth/auth';
import User from './user/user';
import LoginModalHelper from './helpers/login-modal-helper';
import Credit from './credit/credit';
import CookieHelper from './helpers/cookie-helper';
import NavbarDisplay from './navbar/navbar-display';
import {chat} from '../../lucky-balls/js/chat';

let api = new Api(API_URL + '/horse-racing');
let user = new User();
let auth = new Auth(api);
let credit = new Credit(api);
let navbar = new NavbarDisplay();

let odds = [
'WinOdd1', 'WinOdd2', 'WinOdd3', 'WinOdd4', 'WinOdd5', 'WinOdd6', 'WinOdd7', 'WinOdd8',
'InFirstTwoOdd1', 'InFirstTwoOdd2', 'InFirstTwoOdd3', 'InFirstTwoOdd4', 'InFirstTwoOdd5', 'InFirstTwoOdd6', 'InFirstTwoOdd7', 'InFirstTwoOdd8',
'InFirstThreeOdd1', 'InFirstThreeOdd2', 'InFirstThreeOdd3', 'InFirstThreeOdd4', 'InFirstThreeOdd5', 'InFirstThreeOdd6', 'InFirstThreeOdd7', 'InFirstThreeOdd8',
'Win5678Odd', 'Win1234Odd',
'WinOddOdd', 'WinEvenOdd',
'FirstTwoLess95Odd', 'FirstTwoMore95Odd',
'FirstThreeLess125Odd', 'FirstThreeMore125Odd',
'FSOdd1_2', 'FSOdd1_3', 'FSOdd1_4', 'FSOdd1_5', 'FSOdd1_6', 'FSOdd1_7', 'FSOdd1_8',
'FSOdd2_1', 'FSOdd2_3', 'FSOdd2_4', 'FSOdd2_5', 'FSOdd2_6', 'FSOdd2_7', 'FSOdd2_8', 
'FSOdd3_1', 'FSOdd3_2', 'FSOdd3_4', 'FSOdd3_5', 'FSOdd3_6', 'FSOdd3_7', 'FSOdd3_8',
'FSOdd4_1', 'FSOdd4_2', 'FSOdd4_3', 'FSOdd4_5', 'FSOdd4_6', 'FSOdd4_7', 'FSOdd4_8',
'FSOdd5_1', 'FSOdd5_2', 'FSOdd5_3', 'FSOdd5_4', 'FSOdd5_6', 'FSOdd5_7', 'FSOdd5_8',
'FSOdd6_1', 'FSOdd6_2', 'FSOdd6_3', 'FSOdd6_4', 'FSOdd6_5', 'FSOdd6_7', 'FSOdd6_8',
'FSOdd7_1', 'FSOdd7_2', 'FSOdd7_3', 'FSOdd7_4', 'FSOdd7_5', 'FSOdd7_6', 'FSOdd7_8',
'FSOdd8_1', 'FSOdd8_2', 'FSOdd8_3', 'FSOdd8_4', 'FSOdd8_5', 'FSOdd8_6', 'FSOdd8_7',
'DC21Odd', 'DC31Odd', 'DC32Odd', 'DC41Odd', 'DC42Odd', 'DC43Odd', 'DC51Odd', 'DC52Odd', 'DC53Odd', 'DC54Odd', 'DC61Odd', 'DC62Odd', 'DC63Odd', 'DC64Odd', 'DC65Odd',
'DC71Odd', 'DC72Odd', 'DC73Odd', 'DC74Odd', 'DC75Odd', 'DC76Odd', 'DC81Odd', 'DC82Odd', 'DC83Odd', 'DC84Odd', 'DC85Odd', 'DC86Odd', 'DC87Odd', 
];

let horseClass = {
    1 : 'red-horse',
    2 : 'grey-horse',
    3 : 'blue-horse',
    4 : 'yellow-horse',
    5 : 'green-horse',
    6 : 'black-horse',
    7 : 'purple-horse',
    8 : 'orange-horse',
};


let videoList = [
'1-1_678','1-3_126','1-5_524','1-7_846','10-1_623','10-2_462','10-4_657','10-6_814','10-7_853','10-8_764','11-1_783','11-2_214','11-3_482','11-4_721','11-5_786','11-6_824',
'11-7_126','11-8_428','12-1_716','12-3_364','12-5_278','12-7_378','12-8_247','13-1_574','13-3_468','13-4_162','13-6_215','13-7_735',
'13-8_543','14-1_415','14-3_163','14-4_245','14-5_564','14-6_274','14-7_314','15-1_261','15-2_431','15-3_284','15-4_152','15-5_534',
'15-6_738','15-7_426','15-8_472','16-2_152','16-3_617','16-7_824','17-1_318','17-2_852','17-3_382','17-5_675','17-6_862','18-1_281',
'18-3_725','18-5_572','18-8_613','19-1_178','19-2_156','19-4_586','19-5_518','19-6_568','19-7_641','19-8_375','2-1_867','2-3_614',
'2-5_583','2-6_478','2-7_716','2-8_746','20-1_481','20-2_342','20-3_863','20-4_358','20-5_685','20-6_635','20-7_532','20-8_578','21-1_765','21-3_584','21-4_346',
'21-6_756','21-8_134','22-1_865','22-2_841','22-5_671','22-6_874','22-8_342','23-2_456','23-3_185',
'23-4_325','23-5_176','23-6_572','23-7_147','23-8_342','24-1_845','24-2_174','24-3_231','24-4_148','24-5_723',
'24-7_347','24-8_213','25-2_741','25-3_746','25-4_862','25-5_546','25-6_136','25-8_371','26-1_751','26-2_638','26-4_126',
'26-5_523','26-6_284','26-8_564','27-2_578','27-3_432','27-4_524','27-5_851','27-6_754','27-7_163','27-8_127',
'28-1_317','28-2_568','28-3_453','28-4_836','28-5_627','28-6_275','28-7_185','28-8_642','29-1_124','29-2_216',
'29-3_824','29-5_562','29-6_831','29-8_718','3-2_317','3-3_348','3-4_658','3-5_175','3-6_561','3-7_761',
'3-8_483','30-1_143','30-2_615','30-3_782','30-4_815','30-5_657','30-7_126','30-8_682','31-1_514','31-2_263','31-3_315',
'31-4_453','31-5_154','31-6_632','31-7_254','31-8_721','32-3_145','32-4_751','32-7_572','32-8_674','33-1_158','33-4_423','33-5_716','33-6_276','33-7_631',
'34-1_725', '34-3_382', '34-4_146','34-5_875','34-6_527','34-7_187','34-8_356','35-1_586','35-3_725','35-4_187','35-5_728','35-6_816','35-8_812','36-1_756','36-2_213',
'36-3_216','36-4_845', '37-1_156','37-3_138','37-4_816','37-6_184','37-7_745','37-8_317','39-1_816','39-2_257','39-3_273','39-5_146','39-6_312',
'39-7_426','39-8_146','4-3_615','4-4_875','4-5_516','4-7_814','4-8_534','40-1_158','40-2_138','40-3_421','40-6_256','40-7_376','40-8_132','41-1_578','41-3_745',
'41-6_351','41-7_271','42-1_135','42-3_341','42-4_642','42-6_785','42-7_138','42-8_356','43-1_372','43-2_124','43-3_437','43-5_852','43-6_271','43-7_756','43-8_157','44-1_627',
'44-2_215','44-3_356','44-5_658', '44-6_573', '45-1_148', '45-2_268', '45-3_463', '45-4_856', '45-6_632', '45-7_285', '45-8_748', '46-1_865', '46-2_186', '46-4_567',
'46-5_176','46-6_538','46-7_183','46-8_162','47-4_345','47-5_637','47-6_361','47-8_457','48-1_743','48-2_642','48-4_867','48-5_475','48-6_674','48-7_748','48-8_458','49-1_572',
'49-2_853','49-4_674','49-5_714','49-6_657','49-7_145','49-8_481','5-1_827', '5-2_681', '5-3_263', '5-4_537', '5-5_731', '5-6_127', '5-7_478', '5-8_521',
'50-2_458', '50-3_861', '50-4_156', '50-6_843', '50-7_756', '50-8_412', '51-1_712', '51-4_274', '51-5_536', '51-6_758', '51-7_341', '52-1_476', '52-2_168', '52-4_746', '52-5_346', 
'52-6_845', '52-7_473', '52-8_681', '53-2_268', '53-3_754', '53-4_456', '53-5_752', '53-6_234', '53-7_765', '53-8_245', '54-1_567', '54-2_864', '54-3_216', 
'54-4_257', '54-5_746', '54-6_576', '54-8_467', '6-1_362', '6-2_823', '6-3_241', '6-4_752', '6-5_512', '6-8_563',
'62-1_874', '62-2_642', '62-3_584', '62-6_412', '62-7_651', '62-8_684', '62-9_163', '63-2_437', '63-3_482', '63-4_182', '63-5_614', '63-6_871', '63-7_562', '63-8_426', '64-2_265',
 '64-3_362', '64-4_247', '64-6_712', '64-7_872', '64-8_754', '64-9_461', '65-3_475', '65-6_213', '65-7_361', '65-8_462', '66-1_726', '66-3_735', '66-5_123', '66-6_132', '66-7_173',
'67-1_362', '67-2_138', '67-3_285', '67-4_236', '67-5_362', '67-8_586', '68-1_637', '68-3_761', '68-4_726', '68-5_318', '69-1_851', '69-2_128', '69-3_823', '69-4_235', '69-5_532', 
'69-8_647','7-1_241', '7-2_538', '7-3_623', '7-4_642', '7-5_751', '7-6_482', '7-8_631', '70-1_537', '70-2_165', '70-3_756', '70-5_871', '70-6_785', '70-7_341',
'8-1_847', '8-2_758', '8-3_467', '8-4_374', '8-5_863', '8-7_273', '8-8_734', '9-1_837', '9-3_452', '9-4_583', '9-8_781'
];

let ticket = {
    winner : {
        gameId : '01',
        gameBet : 0
    } , 
    place : {
        gameId : '05',
        gameBet : 0
    }, 
    show : {
        gameId : '06',
        gameBet : 0
    }, 
    perfecta : {
        gameId : '04',
        gameBet : 0
    }, 
    double_chance : {
        gameId : '07',
        gameBet : 0
    }, 
    low_high : {
        gameId : '14',
        gameBet : 0
    },
    odd_even : {
        gameId : '15',
        gameBet : 0
    }, 
    sum123 : {
        gameId : '17',
        gameBet : 0
    }, 
    sum12 : {
        gameId : '16',
        gameBet : 0
    }
};

window.addEventListener('get_tickets_no_stats', function () {
    getTickets();
});

// register login event listener
window.addEventListener('logout', function () {
    auth.logout();
});

window.addEventListener('get_credit', function () {
    credit.getCredit(user);
});

window.addEventListener('payout', function () {
    credit.requestPayout(user);
});

function loginManagement(auth, user, navbar, credit)  {

    if (user.isLogggedIn()) {
      window['token'] = CookieHelper.get('token');
      // make fake response object
      let response = {
        Data: {
          AuthUserResponse: [
            {
              Credit: credit.getCredit(user),
              Currency: CookieHelper.get('currency')
            }
          ]
        }
      };
    
      navbar.showLogedIn(user, response);
  
    } else {
      navbar.showLogedOut();
    }
  
  
    $('.logout-button').click(() => {
      var logoutEvent = new CustomEvent("logout");
      window.dispatchEvent(logoutEvent);
    });
  
    $('.login-button').click(() => {
      $('.login-modal').modal('show');
    });
    
    $('.login-user-button').click(() => {
      auth.login(LoginModalHelper.bind(user));
    });
  
    $('.user-username').on('keydown', function(e) {
      if (e.which == 13) {
        auth.login(LoginModalHelper.bind(user));
      }
    });
  
    $('.user-password').on('keydown', function(e) {
      if (e.which == 13) {
        auth.login(LoginModalHelper.bind(user));
      }
    });
    
    $('.login-modal').on('hidden.bs.modal', function () {
      LoginModalHelper.clearloginInputs();
    });

    $('.payout-pin-button').click(() => {
        var payoutEvent = new CustomEvent("payout");
        window.dispatchEvent(payoutEvent);
    });
  }

$(document).ready(function(){
    init(odds);

     $('.select-bet').click(function(){
        let bet = $(this).data('bet');
        ticket[bet].gameBet = $(this).data('value');
        $('*[data-bet="'+bet+'"]').removeClass('betting-dogs-btn-red');
        $(this).addClass('betting-dogs-btn-red');
    });

    /**
     * Betting amount - allow only positive numbers and dot.
     */
    document.getElementById('betting-amount').onkeydown = (e) => {
        var value =  e.target.value;
        //only allow a-z, A-Z, digits 0-9 and comma, with only 1 consecutive comma ...
        if (!e.key.match(/[0-9.BackSpaceDelete]/) || (e.key == '.' && value[value.length-1] == '.')) {
        e.preventDefault();  
        }
    }

    /**
    * Window token promise.
    */
   const getTokenPromise = () => {
    let tokenPromise = new Promise((resolve, reject) => {
      window.addEventListener("message", (event) => {
        try {
          if (JSON.parse(event.data).payload.action == 'login') {
            window['customLoggedIn'] = true;
            if (!JSON.parse(event.data).payload.token) {
              reject(new Error('Empty Token Recieved'))
            }
            window['customToken'] = JSON.parse(event.data).payload.token;
            resolve(window['customToken']);
          } 
        } catch (error) {
          reject(error);
        }
    }, false);
       window['customToken'] ? resolve(window['customToken']) : '';
    });
    
    return tokenPromise;
  }

    /**
     * Pre Buy Logic.
     */
    const buyTicketAdapter = () => {
        var totalBets = 0;
        var prepareTicket = "|";
        var bettingAmount = parseFloat($('#betting-amount').val());

        for(var key in ticket) {
            if (ticket.hasOwnProperty(key)) {
                if(ticket[key].gameBet != 0){
                    totalBets++;
                    prepareTicket += ticket[key].gameId + pad(ticket[key].gameBet, 3)+'|'
                }
            }
        }

        /* if(typeof window.token == 'undefined' || window.token == 'null' || window.token == null || window.token == '' || window.token == 0  || window.token == 'NULL'){
            $('#modal-title').text(langArr[language].please_login);
            $('#gameModal').modal('show');
            return false;
        } */

        if(totalBets == 0){
            //alert('Please select at least one combination.');
            $('#modal-title').text(langArr[language].chose_some_bets);
            $('#gameModal').modal('show');
            return false;
        }
        if(isNaN(bettingAmount) || bettingAmount == 0){
            //alert('Please select valid betting amount.');
            $('#modal-title').text(langArr[language].chose_valid_amount);
            $('#gameModal').modal('show');
            return false;
        }

        if (parseFloat(bettingAmount) < parseFloat($('#Horse8_MinBet').data('value'))) {
            $('#modal-title').text(langArr[language].minimum_stake_is + " " + $('#Horse8_MinBet').data('value'));
            $('#gameModal').modal('show');
            return false;
        }

        if (parseFloat(bettingAmount) > parseFloat($('#Horse8_MaxBet').data('value'))) {
            $('#modal-title').text(langArr[language].maximum_stake_is + " " + $('#Horse8_MaxBet').data('value'));
            $('#gameModal').modal('show');
            return false;
        }

        if (CookieHelper.get('uName') !== undefined && CookieHelper.get('uName') != '' && CookieHelper.get('uName') != null) {
            credit.getAsyncCredit(user).then(function(deposit)  {
                if (parseFloat(bettingAmount) > parseFloat(deposit)) {
                    $('#modal-title').text(langArr[language].you_dont_have_enough_deposit);
                    $('#gameModal').modal('show');
                    return false;
                }
                buyTicket(prepareTicket, bettingAmount);
                oldTicket = ticket;
                var oldBettingAmount = bettingAmount;
                resetTicket();   
            }); 
        } else {
            buyTicket(prepareTicket, bettingAmount);
            oldTicket = ticket;
            var oldBettingAmount = bettingAmount;
            resetTicket();   
        }     
    }

    /**
     * Test is JSON string.
     * 
     * @param {string} str 
     */
    const isJsonString = (str) => {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }

     /**
     * On custom logout message from parent iframe
     */
    window.addEventListener("message", (event) => {
        try {
          if (!isJsonString(event)) {
            if (JSON.parse(event.data).payload.action == 'customLogout') {
              window['customLoggedIn'] = true;
              window['customToken'] = '';
            } 
          }
        } catch (error) {
          console.log(error);
        }
    }, false);
    
    /**
     * User Authetication.
     */
    const authenticate = async () => {
        if(!window['token']) {
            // if loginpopup=0 in url
             if (/loginpopup=0/.test(window['location']['href'])) {
                if (window['customLoggedIn'] && window['customToken']) {
                  buyTicketAdapter();
                } else {
                  // If no login token set, send login required msg to parent iframe
                  window['parent'].postMessage(JSON.stringify({
                    source:"elbet-messages",
                    payload:{action:"loginRequired"}
                  }),'*');
                  try {
                    await getTokenPromise();
                  } catch (error) {
                        // Game specific logic for clearing bets
                        resetTicket();   
                        /* this.saveLastBet();
                        this.clearBets(); */
                        //$('#buy-ticket-button').removeAttr('disabled');
                    return;
                  }
                  buyTicketAdapter();
                }     
             } else {
                $('#modal-title').text(langArr[language].please_login);
                $('#gameModal').modal('show');

                return;
            }
          } else {
            // If there is a url token ie window['token']
            if (/loginpopup=0/.test(window['location']['href'])) {
              // if customLogged in true and no customToken then request login 
              // (which means that login was initiated before but token has been removed)
              if (window['customLoggedIn'] && !window['customToken']) {
                  window['parent'].postMessage(JSON.stringify({
                  source:"elbet-messages",
                  payload:{action:"loginRequired"}
                }),'*');
                try {
                  await getTokenPromise();
                } catch (error) {
                    // Game specific logic for clearing bets
                    resetTicket();   
                 /*  this.saveLastBet();
                  this.clearBets();
                  $('#buy-ticket-button').removeAttr('disabled'); */
                  return;
                }
                buyTicketAdapter();
              } else {
                buyTicketAdapter();
              } 
            } else {
                buyTicketAdapter();
            }
        }
    }

     $('#buyTicket').click(function(e){
        e.stopImmediatePropagation();
        authenticate();
    });

    $('#delete-bets').click(function(){
        resetTicket();
    });
   
    $('.set-bet').click(function(){
        $('#betting-amount').val($(this).data('value'))
    });


    $('#gameModal').on('hidden.bs.modal', function () {
        $('#modal-title').text('');
    });

    $('#repeatTicket').click(function(){
        var n =0;
        for(var key in oldTicket) {
            if (oldTicket.hasOwnProperty(key)) {
                if(oldTicket[key].gameBet != 0){
                   
                       $('[data-bet="'+key+'"][data-value="'+oldTicket[key].gameBet+'"]').click();
                  
                   n++;
                }
            }
        }

        if(n > 0){
            $('#betting-amount').val(window.oldBettingAmount)
        }

    });
    
    setLangText();
});

function setLangText()
{
    $("[data-langName]").map(function(){
        var langName = $(this).attr('data-langName');
        $(this).text(langArr[language][langName]);
    });
}


function init(odds){
    getDefaults();
    var raceData = raceInfo();
    //console.log(raceData)
    var raceStatus = raceData['Horse8Race'][0]['RaceStatus'];
    var raceTime = raceData['Horse8Race'][0]['RaceTimer'];
    var raceTimerResult = raceData['Horse8Race'][0]['RaceTimerResult'];
    var nextTimer = raceStatus == 0 ? raceTime : raceTimerResult;
    handleBettingScreen(raceStatus, nextTimer);
    fillQuotes(raceData, odds);
    var videoName= raceData['Horse8Race'][0]['Winner']+'-'+ raceData['Horse8Race'][0]['SecondPlace']+'-'+raceData['Horse8Race'][0]['ThirdPlace']
    if(raceStatus == 1) {
        var argRaceData = raceData['Horse8Race'][0];
        createFinishScreen(argRaceData);
        showFinishScreen(raceData);
    }
}

function showNavbar(){
    // checks if showLogin response is set to 1
    if (window['showLogin'] == 1) {
        $('.game-nav-bar').css('display', 'flex');
    } else {
        $('.game-nav-bar').css('display', 'none');
    }
}

/* API CALLS */

function getDefaults() {
    $.ajax({
        url: API_URL + '/luckyballs/game-config/get',
        type: "post",
           data: {},
           success: function (response) {
               window['menu'] = (response['Online_Menu'] !== undefined && response['Online_Menu'] != '' && response['Online_Menu'] != null) ? response['Online_Menu'] : false;
               if(window['menu']) {
                   $("#nav-icon1").show();
                   window['renderMenu']();
               }
              window['currency'] =  response.Currency;
              window['showLogin'] =  (response['showLogin'] !== undefined && response['showLogin'] != '' && response['showLogin'] != null) ? response['showLogin'] : 0;
              $('#currency').text(window['currency']);
              $('#Horse8_MaxBet').data('value', response.Horse8_MaxBet);
              $('#Horse8_MinBet').data('value', response.Horse8_MinBet);
              $('#betting-amount').val(response.Horse8_MinBet);
              $('#jackpot').html(response.Horse8_JackPotValue);
              $('#CustomAmount1').text(response.CustomAmount1).data('value', response.CustomAmount1)
              $('#CustomAmount2').text(response.CustomAmount2).data('value', response.CustomAmount2)
              $('#CustomAmount3').text(response.CustomAmount3).data('value', response.CustomAmount3);
              showNavbar();
              // manages any click and login/logout events
              loginManagement(auth, user, navbar, credit);
              // Call chat script
              if (window['token'] && !/terminal/.test(window.location.href)) {
                chat(window['token']);
              }

              getTickets();
          },
          error: function(jqXHR, textStatus, errorThrown) {
              if(debug){
                  alert(errorThrown)
              }
          }
      });
}

function raceInfo(){
    let tmp = null;
    $.ajax({
        'async': false,
        'type': "POST",
        'global': false,
        'dataType': 'json',
        url: API_URL + '/horse-racing/game/get',
        'data': {},
        'success': function (data) {
            $('#roundNr').text(data['Horse8Race'][0]['ID_Today']);
            //$('#jackpot').text(data['Horse8Race'][0]['Dog6_JackPotValue']);
            // data['Horse8Race'][0].RaceJackPotCode
             tmp = data;
        }
    });
    return tmp;
}

// Buy tickets
function buyTicket(ticket, amount){
    $('#mask').show();

    $.ajax({
        url: API_URL + '/horse-racing/ticket/buy',
        type: "post",
           data: { TicketAmount: amount, Items : ticket, SessionID: CookieHelper.get('token') != '' ? CookieHelper.get('token') : window['token'] } ,
           success: function (response) {
            if (response.Status == 0) {
                $('#modal-title').text(langArr[language].error_purchasing_ticket);
                $('#gameModal').modal('show');
                return false;
            } else {
                resetTicket();
                getTickets();
                var updateCreditEvent = new CustomEvent("get_credit");
                window.dispatchEvent(updateCreditEvent);
                $('#mask').hide();
                $('#buyTicketModal').modal('show');
                if ("TicketData" in response) {
                    if ("Horse8Ticket" in response.TicketData) {
                        $('#boughtTicketId').html(" ID " + response.TicketData.Horse8Ticket[0].TicketID);
                    }
                }
                setTimeout(function(){
                  $('#buyTicketModal').modal('hide');
                  $('#boughtTicketId').html('');
                }, 2000);
            }
          },
          error: function(jqXHR, textStatus, errorThrown) {
              if(debug){
                  alert(errorThrown)
              }

          }
      });
}

// Get tickets for current game
function getTickets(){
    $.ajax({
        url: API_URL + '/horse-racing/ticket/get',
        type: "post",
           data: {SessionID: CookieHelper.get('token') != '' ? CookieHelper.get('token') : window['token'] },
           success: function (response) {
               drawTickets(response)
              // console.log(response)
           },
           error: function(jqXHR, textStatus, errorThrown) {
               if(debug){
                   console.log(jqXHR.responseText)
               }
               
           }
       });
}


/* SCREEN FUNCTIONS */

function fillQuotes(quotes, odds){
    let obj = $.extend({}, quotes['Horse8Race'][0]);
    let obj2 = quotes['Horse8Race'][0];
    $.each(odds, function(index, item) {
        $('#'+item).text(obj2[item])
    }, obj);

}

function handleBettingScreen(raceStatus, nextTimer){
    handleGameMask(raceStatus);
    $('.dog-racing-video-player').hide();
    $('.dog-racing-video-holder').show();
    if(raceStatus == 0){
        waitRace(nextTimer);
    }else{
        waitRaceFinish(nextTimer);

    }
}

function handleGameMask(raceStatus){
    if(raceStatus == 0){
        $('#mask').hide()
    }else{
        $('#mask').show()
    }
}

function showWaitingEmptyScreen(){
    $('#video-main').addClass('waiting');
}


function loaderPercentage(maxNum, newNum){
    var percentage = newNum/maxNum*100;
    $('.vdh-progress-bar').css({'width' : percentage+'%'})
}

function openBets(){
    
    $('#video-main').removeClass('waiting');
    var raceData = raceInfo();
    var video = $("#video-holder video")[0];
    video.pause();
    video.src = '';
    var jackpot = raceData['Horse8Race'][0]['RaceTimer'];
    var jackpotText = jackpot
    fillQuotes(raceData, odds);
    waitRace(raceData['Horse8Race'][0]['RaceTimer'])
    showFinishScreen();
    handleGameMask(0);
    getTickets();
}

// Draw tickets
function drawTickets(data){
    if(data.Data.length == 0) {
        $('#ticketsScroll').html('');
        $('#ticketsScroll').html('<div style="text-align:center; padding-top:30px; color:#fff; font-size:16px;">'+langArr[language].no_tickets_for_current_game+'</div>')
    } else {
        $('#ticketsScroll').html('');

        data.Data.sort(function(a,b){
            return b.TicketTime<a.TicketTime; 
        })

        for (var i = data.Data.length - 1; i >= 0; i--) {

            var winer = data.Data[i].ticket.hasOwnProperty('winner')  ? data.Data[i].ticket.winner.odd : '';
            var winerClass = winer == '' ? '' : 'highlightTicket';
            var winerBox = winer == '' ? '' : horseClass[winer];


            var place = data.Data[i].ticket.hasOwnProperty('place') ? data.Data[i].ticket.place.odd : '';
            var placeClass = place == '' ? '' : 'highlightTicket';
            var placeBox = place == '' ? '' : horseClass[place];

            var show  = data.Data[i].ticket.hasOwnProperty('show')  ? data.Data[i].ticket.show.odd : '';
            var showClass = show == '' ? '' : 'highlightTicket';
            var showBox = show == '' ? '' : horseClass[show];

            var low_high  = data.Data[i].ticket.hasOwnProperty('low_high')  ? data.Data[i].ticket.low_high.odd : '';
            var low_highClass = low_high == '' ? '' : 'highlightTicket';
            var lowClass = low_high == 1 ? 'highlightTicket' : '';
            var highClass = low_high == 2 ? 'highlightTicket' : '';
            var low_highLowOddValue = low_high == 1 ?  data.Data[i].ticket.low_high.OddValue : '';
            var low_highHighOddValue = low_high == 2 ?  data.Data[i].ticket.low_high.OddValue : '';

            var odd_even  = data.Data[i].ticket.hasOwnProperty('odd_even')  ? data.Data[i].ticket.odd_even.odd : '';
            var odd_evenClass = odd_even == '' ? '' : 'highlightTicket';
            var oddClass = odd_even == 2 ? 'highlightTicket' : '';
            var evenClass = odd_even == 1 ? 'highlightTicket' : '';
            var odd_evenOddOddValue = odd_even == 2 ?  data.Data[i].ticket.odd_even.OddValue : '';
            var odd_evenEvenOddValue = odd_even == 1 ?  data.Data[i].ticket.odd_even.OddValue : '';

            var sum12  = data.Data[i].ticket.hasOwnProperty('sum12')  ? data.Data[i].ticket.sum12.odd : '';
            var sum12Class = sum12 == '' ? '' : 'highlightTicket';
            var sum12minusClass = sum12 == 1 ? 'highlightTicket' : '';
            var sum12plusClass = sum12 == 2 ? 'highlightTicket' : '';
            var sum12minusOddValue = sum12 == 1 ?  data.Data[i].ticket.sum12.OddValue : '';
            var sum12plusOddValue = sum12 == 2 ?  data.Data[i].ticket.sum12.OddValue : '';

            var sum123  = data.Data[i].ticket.hasOwnProperty('sum123')  ? data.Data[i].ticket.sum123.odd : '';
            var sum123Class = sum123 == '' ? '' : 'highlightTicket';
            var sum123minusClass = sum123 == 1 ? 'highlightTicket' : '';
            var sum123plusClass = sum123 == 2 ? 'highlightTicket' : '';
            var sum123minusOddValue = sum123 == 1 ?  data.Data[i].ticket.sum123.OddValue : '';
            var sum123plusOddValue = sum123 == 2 ?  data.Data[i].ticket.sum123.OddValue : '';

            var double_chance  = data.Data[i].ticket.hasOwnProperty('double_chance')  ? data.Data[i].ticket.double_chance.odd : '';
            var double_chanceClass = double_chance == '' ? '' : 'highlightTicket';
            var double_chanceFirst = '';
            var double_chanceSecond = '';
            var double_chanceFirstClass = '';
            var double_chanceSecondClass = '';
            var double_chanceOddValue = '';
            var double_chancePlay = 0;
            if(double_chance != ''){
                double_chanceFirst = data.Data[i].ticket.double_chance.Description.charAt(3);
                double_chanceSecond = data.Data[i].ticket.double_chance.Description.charAt(4);
                double_chanceFirstClass = horseClass[double_chanceFirst];
                double_chanceSecondClass = horseClass[double_chanceSecond];
                double_chanceOddValue = data.Data[i].ticket.double_chance.OddValue;
                double_chancePlay = double_chanceFirst+'-'+double_chanceSecond;
            }
            

            // Perfecta
            var perfecta  = data.Data[i].ticket.hasOwnProperty('perfecta')  ? data.Data[i].ticket.perfecta.odd : '';
            var perfectaClass = perfecta == '' ? '' : 'highlightTicket';
            var perfectaFirst = '';
            var perfectaSecond = '';
            var perfectaFirstClass = '';
            var perfectaSecondClass = '';
            var perfectaOddValue = '';
            var perfectaPlay = 0;
            if(perfecta != ''){
                perfectaFirst = data.Data[i].ticket.perfecta.Description.split("-")[0];
                perfectaSecond = data.Data[i].ticket.perfecta.Description.split("-")[1];
                perfectaFirstClass = horseClass[perfectaFirst];
                perfectaSecondClass = horseClass[perfectaSecond];
                perfectaOddValue = data.Data[i].ticket.perfecta.OddValue;
                perfectaPlay = perfectaFirst+'-'+perfectaSecond;
            }

            $('#ticketsScroll').append('<div class="ticket-holder" id="ticket_holder_'+data.Data[i].TicketID+'"></div>');
            $('#ticket_holder_'+data.Data[i].TicketID).append('<div class="ticket-bar clearfix"><div class="ticket-bar-left">Ticket ID : '+data.Data[i].TicketID+'</div><div class="ticket-bar-right">'+data.Data[i].TicketAmount+' '+window['currency']+' </div></div><div class="ticket-content" id="ticket_content_'+data.Data[i].TicketID+'"></div>')
            $('#ticket_content_'+data.Data[i].TicketID).append('<div class="ticket-dogs-statistic"><div class="tds-holder '+winerClass+'" id="winner_'+data.Data[i].TicketID+'">'+langArr[language].winner+'<input class="tds-input '+winerBox+'" type="text" readonly value="'+winer+'" /></div><div class="tds-holder '+placeClass+'" id="place_'+data.Data[i].TicketID+'">'+langArr[language].place+'<input class="tds-input '+placeBox+'" type="text" readonly value="'+place+'" /></div><div class="tds-holder"><span class="tds-holder-dark '+showClass+'" id="show_'+data.Data[i].TicketID+'">'+langArr[language].show+'</span><input class="tds-input '+showBox+'" type="text" readonly value="'+show+'" /></div></div>');
            $('#ticket_content_'+data.Data[i].TicketID).append('<div class="ticket-dogs-title" id="perfectaTitle_'+data.Data[i].TicketID+'" data-play="'+perfectaPlay+'" >'+langArr[language].perfecta+'</div><div class="ticket-dogs-statistic" id="perfecta_'+data.Data[i].TicketID+'"><div class="tds-holder"><input class="tds-input tds-input-fullwidth" type="text" readonly value="'+perfectaOddValue+'"/></div><div class="tds-holder"><span class="tds-holder-dark '+perfectaClass+'">'+langArr[language].winner+'</span><input class="tds-input '+perfectaFirstClass+'" readonly value="'+perfectaFirst+'" type="text"/></div><div class="tds-holder"><span class="tds-holder-dark '+perfectaClass+'">'+langArr[language].second+'</span><input class="tds-input '+perfectaSecondClass+'" readonly value="'+perfectaSecond+'" type="text"/></div></div>')
            $('#ticket_content_'+data.Data[i].TicketID).append('<div class="ticket-dogs-statistic"><div><div class="ticket-dogs-title '+double_chanceClass+'" id="doubleChanceTitle_'+data.Data[i].TicketID+'" data-play="'+double_chancePlay+'">'+langArr[language].double_chance+'</div><input class="tds-input tds-input-fullwidth" value="'+double_chanceOddValue+'" readonly type="text"/><input class="tds-input '+double_chanceFirstClass+'" value="'+double_chanceFirst+'" readonly type="text"/><input class="tds-input '+double_chanceSecondClass+'" readonly value="'+double_chanceSecond+'" type="text"/></div></div>')
            $('#ticket_content_'+data.Data[i].TicketID).append('<div class="ticket-dogs-title" id="lowHighTitle_'+data.Data[i].TicketID+'">'+langArr[language].low+' / '+langArr[language].high+'</div><div class="ticket-dogs-statistic"><div class="ticket-dogs-left '+lowClass+'" data-ticketbet="low">1, 2, 3, 4 / '+low_highLowOddValue+'</div><div class="ticket-dogs-right '+highClass+'" data-ticketbet="high">5, 6, 7, 8 / '+low_highHighOddValue+'</div></div>')
            $('#ticket_content_'+data.Data[i].TicketID).append(' <div class="ticket-dogs-title" id="oddEvenTitle_'+data.Data[i].TicketID+'">'+langArr[language].odd+' / '+langArr[language].even+'</div><div class="ticket-dogs-statistic"><div class="ticket-dogs-left '+evenClass+'" data-ticketbet="even">Even / '+odd_evenEvenOddValue+'</div><div class="ticket-dogs-right '+oddClass+'" data-ticketbet="odd">Odd / '+odd_evenOddOddValue+'</div></div>')
            $('#ticket_content_'+data.Data[i].TicketID).append('<div class="ticket-dogs-title" id="sum123Title_'+data.Data[i].TicketID+'">'+langArr[language].sum+'  1+2+3</div><div class="ticket-dogs-statistic"><div class="ticket-dogs-left '+sum123minusClass+'" data-ticketbet="minus">< 12.5 / '+sum123minusOddValue+' </div><div class="ticket-dogs-right '+sum123plusClass+'" data-ticketbet="plus">> 12.5 / '+sum123plusOddValue+' </div></div>')
            $('#ticket_content_'+data.Data[i].TicketID).append(' <div class="ticket-dogs-title" id="sum12Title_'+data.Data[i].TicketID+'">'+langArr[language].sum+'  1+2</div><div class="ticket-dogs-statistic"><div class="ticket-dogs-left '+sum12minusClass+'" data-ticketbet="minus"><9.5 / '+sum12minusOddValue+'</div><div class="ticket-dogs-right '+sum12plusClass+'" data-ticketbet="plus">>9.5 / '+sum12plusOddValue+'</div></div>')
            $('#ticket_content_'+data.Data[i].TicketID).append(' <div class="jackpot-code jackpot-dogs-code"><span class="tsh-cr-down-red">'+langArr[language].jackpot_code+': </span></div>')
        }

        var drawTicketsEvent = new CustomEvent("onTicketReady", {
            detail: null
        })
        dispatchEvent(drawTicketsEvent);
    }

}

function showTicketsResult(data){

    var first = data['Horse8Race'][0]['Winner'];
    var second = data['Horse8Race'][0]['SecondPlace'];
    var third = data['Horse8Race'][0]['ThirdPlace'];

    var perfecta = first+'-'+second;

    var tickets = $(".ticket-holder").map(function () {
        
       var ticketId = $(this).attr('id').split('_')[2];
       // Highlight winner
       if($('#winner_'+ticketId).hasClass('highlightTicket') ){
           var _thisWinner = $('#winner_'+ticketId)
           if($('.tds-input', _thisWinner).val() == first){
               $('#winner_'+ticketId).addClass('successBet')
               $('#ticket_holder_' + ticketId).addClass('winning-ticket')
           }
       }

       // Highlight second
       if($('#place_'+ticketId).hasClass('highlightTicket')){
           var _thisPlace = $('#place_'+ticketId)
           if($('.tds-input', _thisPlace).val() == first || $('.tds-input', _thisPlace).val() == second){
               $('#place_'+ticketId).addClass('successBet')
               $('#ticket_holder_' + ticketId).addClass('winning-ticket')
           }
       }

       // Highlight third
       if($('#show_'+ticketId).hasClass('highlightTicket')){
           var _thisShow = $('#show_'+ticketId).parent()
           if($('.tds-input', _thisShow).val() == first || $('.tds-input', _thisShow).val() == second || $('.tds-input', _thisShow).val() == third ){
               $('#show_'+ticketId).addClass('successBet')
               $('#ticket_holder_' + ticketId).addClass('winning-ticket')
           }
       }

       // Highlight perfecta
       if($('#perfectaTitle_'+ticketId).data('play') != '0'){
           if($('#perfectaTitle_'+ticketId).data('play') == perfecta){
               $('#perfectaTitle_'+ticketId).addClass('successBet')
               $('#ticket_holder_' + ticketId).addClass('winning-ticket')
           }
       }

         if($('#doubleChanceTitle_'+ticketId).data('play') != '0'){
           var doubleChancePlay = $('#doubleChanceTitle_'+ticketId).data('play');
           var doubleChancecCombination1 = second+'-'+first;
           var doubleChancecCombination2 = first+'-'+second;
           if($('#doubleChanceTitle_'+ticketId).data('play') == doubleChancecCombination1 || $('#doubleChanceTitle_'+ticketId).data('play') == doubleChancecCombination2){
               $('#doubleChanceTitle_'+ticketId).addClass('successBet')
               $('#ticket_holder_' + ticketId).addClass('winning-ticket')
           }
       }

       
       // Low/ high highlight
       var _thisLowHigh = $('#lowHighTitle_'+ticketId).next();
       var lowHighPlayed = $('.highlightTicket', _thisLowHigh).data('ticketbet');
       // Highlight low high
       if(lowHighPlayed == 'low' || lowHighPlayed == 'high'){
           if(lowHighPlayed == 'low'){
               if(first == 1 || first == 2 || first == 3 || first == 4 ){
                   $('.highlightTicket', _thisLowHigh).addClass('successBet')
                   $('#ticket_holder_' + ticketId).addClass('winning-ticket')
               }
           }
           if(lowHighPlayed == 'high'){
               if(first == 5 || first == 6 || first == 7 || first == 8){
                   $('.highlightTicket', _thisLowHigh).addClass('successBet')
                   $('#ticket_holder_' + ticketId).addClass('winning-ticket')
               }
           }
          
       }

        // Odd / Even highlight
       var _thisOddEven = $('#oddEvenTitle_'+ticketId).next();
       var oddEvenPlayed = $('.highlightTicket', _thisOddEven).data('ticketbet');

       if(oddEvenPlayed == 'odd' || oddEvenPlayed == 'even'){
           if(oddEvenPlayed == 'odd'){
               if(first == 1 || first == 3 || first == 5 || first == 7){
                   $('.highlightTicket', _thisOddEven).addClass('successBet')
                   $('#ticket_holder_' + ticketId).addClass('winning-ticket')
               }
           }
           if(oddEvenPlayed == 'even'){
               if(first == 2 || first == 4 || first == 6 || first == 8){
                   $('.highlightTicket', _thisOddEven).addClass('successBet')
                   $('#ticket_holder_' + ticketId).addClass('winning-ticket')
               }
           }
          
       }

       // Sum 123 highlight
       var _thisSum123 = $('#sum123Title_'+ticketId).next();
       var sum123Played = $('.highlightTicket', _thisSum123).data('ticketbet');
       var sum123 = first + second + third;
       if(sum123Played == 'minus' || sum123Played == 'plus'){
           if(sum123Played == 'minus'){
               if(sum123 < 10.5){
                   $('.highlightTicket', _thisSum123).addClass('successBet')
                   $('#ticket_holder_' + ticketId).addClass('winning-ticket')
               }
           }
           if(sum123Played == 'plus'){
               if(sum123 > 10.5){
                   $('.highlightTicket', _thisSum123).addClass('successBet')
                   $('#ticket_holder_' + ticketId).addClass('winning-ticket')
               }
           }
       }

       // Sum 12 highlight
       var _thisSum12 = $('#sum12Title_'+ticketId).next();
       var sum12Played = $('.highlightTicket', _thisSum12).data('ticketbet');
       var sum12 = first + second;
       if(sum12Played == 'minus' || sum12Played == 'plus'){
           if(sum12Played == 'minus'){
               if(sum12 < 7.5){
                   $('.highlightTicket', _thisSum12).addClass('successBet')
                   $('#ticket_holder_' + ticketId).addClass('winning-ticket')
               }
           }
           if(sum12Played == 'plus'){
               if(sum12 > 7.5){
                   $('.highlightTicket', _thisSum12).addClass('successBet')
                   $('#ticket_holder_' + ticketId).addClass('winning-ticket')
               }
           }
       }

   });

}

/* GAME TIMERS */
function waitRace(raceTime){
    raceTime +=6;
    let raceTimer;
    clearInterval(raceTimer);
    raceTimer = setInterval(function(){

        var newTime = --raceTime;
        $('#fancyTime').text(fancyTimeFormat(newTime));
        loaderPercentage(120, newTime);
        if(raceTime <= 0){
            clearInterval(raceTimer);
            startRace(0);
        }
        
    },1000);
}

function waitRaceFinish(raceTimerResult){
    raceTimerResult +=1;
    let raceTimer;
    clearInterval(raceTimer);
    raceTimer = setInterval(function(){
        var newTime = --raceTimerResult;
       // console.log(fancyTimeFormat(newTime))
       $('#fancyTime').text(fancyTimeFormat(newTime));
       loaderPercentage(70, newTime);
       if(raceTimerResult <= 0){
           var updateCreditEvent = new CustomEvent("get_credit");
           window.dispatchEvent(updateCreditEvent);
           clearInterval(raceTimer);
           openBets();
           showFinishScreen();
       }

   },1000);
}
function startRace(attempt){

    attempt++;
    var raceData = raceInfo();
    var videoTime;

    handleGameMask(1);
    $('#video-main').addClass('waiting');
     
    $('.dog-racing-video-player').show();
    $('.dog-racing-video-holder').hide();

    if(raceData['Horse8Race'][0]['RaceStatus'] == 2 ){
        console.log('No race data');
        setTimeout(function(){
            startRace(attempt);
        }, 4000);
        return false;
    }
  
    if(raceData['Horse8Race'][0]['RaceStatus'] == 0 ){
        init(odds);
        return false;
    }

    if(attempt == 5){
        location.reload();
        return false;
    }
    if(raceData['Horse8Race'][0]['Winner'] == null) {
         setTimeout(function(){
            startRace(attempt);
        }, 3000);
        return false;
    }

    var raceVid = raceData['Horse8Race'][0]['Winner'].toString()+ raceData['Horse8Race'][0]['SecondPlace'].toString()+raceData['Horse8Race'][0]['ThirdPlace'].toString()
    
    var videoFile = searchVideoInArray(raceVid, videoList);

    var video = $("#video-holder video")[0];
    video.src = videoUrl+'/'+videoFile+'.mp4';

    video.load();

    var argRaceData = raceData['Horse8Race'][0];
    createFinishScreen(argRaceData);

    waitRaceFinish(raceData['Horse8Race'][0]['RaceTimerResult']);

    video.addEventListener('loadedmetadata',  function playVideo() {
        var timer1;
        var duration = video.duration.toString();
        var x = duration.split(".")[0];
        var videoTime = parseInt(x) * 1000;
        //iOS
        if (checkIos < 10) {
            $('#video-holder').append('<div class="dog-raciog-ios-less"><div class="apple-inner">'+langArr[language].apple_video_no_support+'</div></div>')
        }else{
             video.play();
        }
       

        timer1 = setTimeout(function(){ 
            if (checkIos < 10) {
                $('.dog-raciog-ios-less').remove();
            }else{ 
                video.pause();
                video.src = '';
            }
            showFinishScreen(raceData); // showTicketsResult(raceData);
         }, videoTime);

        video.removeEventListener('loadedmetadata', playVideo , false);
    });  
}


function showFinishScreen(raceData){
    $('#video-main').removeClass('waiting');
    $('#video-holder').hide();
    $('#finish-screen').show();
    
    if (typeof raceData != 'undefined') {

        function showTicketsResultEvent() {
            showTicketsResult(raceData)
            removeEventListener("onTicketReady", showTicketsResultEvent);
            console.log("TEST EVENT CALL ", raceData);
        }
        addEventListener("onTicketReady", showTicketsResultEvent);
        showTicketsResult(raceData);
    }

}

function createFinishScreen(arg) {

    var name = arg.ID_Today,
        first = arg.Winner,
        second = arg.SecondPlace,
        third = arg.ThirdPlace,
        raceDate = arg.RaceLocalTimeEnd || arg.RaceTimeEnd;

    $('#finish-screen').html('');
    $('#finish-screen').append('<div class="video-round">'+ langArr[language].race +': <span>'+name+'</span></div>')
    $('#finish-screen').append('<div class="video-trophy"><img src="./img/trophy.png" alt=""></div>')
    $('#finish-screen').append('<div class="video-white-line"></div>')
    $('#finish-screen').append('<div class="video-date">'+formatDate(new Date(raceDate))+'</div>')

    $('#finish-screen').append('<div class="video-dog-place"><div class="dog-square-place"><div class="dog-square horse-square '+horseClass[first]+'">'+first+'</div></div><img class="dog-place" src="./img/first.png" /></div>')
    $('#finish-screen').append('<div class="video-dog-place"><div class="dog-square-place"><div class="dog-square horse-square '+horseClass[second]+'">'+second+'</div></div><img class="dog-place" src="./img/second.png" /></div>')
    $('#finish-screen').append('<div class="video-dog-place"><div class="dog-square-place"><div class="dog-square horse-square '+horseClass[third]+'">'+third+'</div></div><img class="dog-place" src="./img/third.png" /></div>')
    $('#finish-screen').append('<div class="video-white-line"></div>')
    $('#finish-screen').append('<div class="jackpotcode">JACKPOT CODE: ' + arg.RaceJackPotCode + '</div>')
}

function resetTicket(){
    ticket = {
        winner : {
            gameId : '01',
            gameBet : 0
        } , 
        place : {
            gameId : '05',
            gameBet : 0
        }, 
        show : {
            gameId : '06',
            gameBet : 0
        }, 
        perfecta : {
            gameId : '04',
            gameBet : 0
        }, 
        double_chance : {
            gameId : '07',
            gameBet : 0
        }, 
        low_high : {
            gameId : '14',
            gameBet : 0
        },
        odd_even : {
            gameId : '15',
            gameBet : 0
        }, 
        sum123 : {
            gameId : '17',
            gameBet : 0
        }, 
        sum12 : {
            gameId : '16',
            gameBet : 0
        }
    }

    $('.select-bet').removeClass('betting-dogs-btn-red').removeClass('betting-dogs-btn-grey');
}

function searchVideoInArray (str, strArray) {

    let matchVideos = [];

    for (var j=0; j<strArray.length; j++) {
        if (strArray[j].match(str)){
            matchVideos.push(j);
        } 
    }
   var randomValue = matchVideos[Math.floor(Math.random() * matchVideos.length)];
   
   return strArray[randomValue];
}

// Sys Functions
function fancyTimeFormat(time)
{   
    // Hours, minutes and seconds
    var hrs = ~~(time / 3600);
    var mins = ~~((time % 3600) / 60);
    var secs = time % 60;

    // Output like "1:01" or "4:03:59" or "123:03:59"
    var ret = "";

    if (hrs > 0) {
        ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
    }

    ret += "0" + mins + ":" + (secs < 10 ? "0" : "");
    ret += "" + secs;
    return ret;
}

function pad(num, size) {
    var s = num+"";
    while (s.length < size) s = "0" + s;
    return s;
}

function isInArray(value, array) {
    return array.indexOf(value) > -1;
}
function formatDate(date) {
  var hours = date.getHours();
  hours = ("0" + hours).slice(-2)
  var minutes = date.getMinutes();
  minutes = ("0" + minutes).slice(-2)

  var strTime = hours + ':' + minutes;
  return date.getDate() + "." + parseInt(date.getMonth() + 1) + "." + date.getFullYear() + "  " + strTime;
}

function iOSversion() {
    if (/iP(hone|od|ad)/.test(navigator.platform)) {
        // supports iOS 2.0 and later: <https://bit.ly/TJjs1V>
        var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
        return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/games/horse-racing/js/horseracing.js
// module id = 1571
// module chunks = 7